var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{ref:"group",attrs:{"config":_vm.clockGroupCnfig},on:{"click":_vm.onGroupClick,"tap":_vm.onGroupClick,"mouseover":_vm.onMouseOver,"mouseout":_vm.onMouseOut}},[_c('v-text',{attrs:{"config":_vm.textConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }